import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import useSocket from "use-socket.io-client";
import clsx from "clsx";
import {
  useAppEvenListSelector,
  useAppEventGameDetailSelector,
  useAppEventGameListSelector,
  useAppGameDetailsSelector,
  useAppNextEventRouteSelector,
  useAppPickIdsSelector,
  useAppRodeoEventLoginRequiredSelector,
} from "src/_common/hooks/selectors/eventSelector";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useAppGuestUserIdSelector, useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import {
  CRYPTO_SECRET_KEY,
  getEventStatusText,
  removeTrailingZero,
  RODEPICK_NEXT_GAME_IDS,
  SOCKET_CHANNEL,
  SOCKET_URL,
  trimTo,
  URLS,
} from "src/_config";
import { toast } from "react-toastify";
import OptionSelectionModal from "../modal/optionSelectionModal";
import GuestSaveVoteModal from "../modal/guestSaveVoteModal";
import StatusModal from "../modal/statusModal";
import GeoLocation from "src/components/common/GeoLocation";
import PickedTeamModal from "../modal/pickedTeamModal";
import Sponsor from "src/components/common/Sponsor";
import ShareModal from "../modal/shareModal";
import moment from "moment";
import QuestionWithOptions from "./questionWithOptions";
import TieBreaker from "./tieBreaker";
import UserAnswers from "./userAnswers";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoQnAPage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const eventAction = useAppEventAction();
  const userAction = useAppUserAction();
  const userDetails = useAppUserDetailsSelector();
  const fromRoute = useAppNextEventRouteSelector();
  const { eventId, performanceId, gameId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  const p_id: number = parseInt(cryptr.decrypt(performanceId));
  const g_id: number = parseInt(cryptr.decrypt(gameId));
  const eventGameDetailsSelector = useAppEventGameDetailSelector();
  const [showOptionSelectionModal, setOptionSelectionModal] = useState<boolean>(false);
  const [showGuestSaveVoteModal, setShowGuestSaveVoteModal] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<any>();
  const eventListSelector = useAppEvenListSelector();
  const guestUserId = useAppGuestUserIdSelector();
  const [nextGameIds, setNextGameIds] = useState<any>([]);
  const pick_id = useAppPickIdsSelector();
  const [nextGameArrayIndex, setNextGameArrayIndex] = useState<any>();
  // const loginReq = useAppRodeoEventLoginRequiredSelector()
  const [loginReq, setLoginReq] = useState<any>(0);
  const [winnerDeclared, setWinnerDeclared] = useState<any>(0);
  const [showStatusModal, setShowStatusModal] = useState<boolean>(false);
  const [statusModalMesssage, setStatusModalMesssage] = useState<any>();
  const [pickStatus, setPickStatus] = useState<any>();
  const gameDetails = useAppGameDetailsSelector();
  const [OptionSelectionModalClosed, setOptionSelectionModalClosed] = useState<boolean>(false);
  const [showPickedTeamModal, setShowPickedTeamModal] = useState<boolean>(false);
  const [congratsShown, setCongratsShown] = useState<boolean>(false);
  const [teamDetails, setTeamDetails] = useState<any>();
  const [tieBreakerCode, setTieBreakerCode] = useState<any>();
  const eventGameListSelector = useAppEventGameListSelector();
  const [performanceDetails, setPerformanceDetails] = useState<any>();
  const [showShareModal, setShowShareModal] = useState<boolean>(false);
  const [url, setUrl] = useState<any>();
  const [contestWinData, setContestWinData] = useState<any>();
  const [anyQuestionsAnswered, setAnyQuestionsAnswered] = useState<boolean>(false);
  const [editAnswer, setEditAnswer] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);

  const submitUserAnswer = () => {
    let params: any = {
      rodeo_event_event_id: g_id,
      rodeo_event_id: e_id,
      performance_id: p_id,
      question_id: eventGameDetailsSelector.events.questions_dtls[currentQuestionIndex].id,
      answer_id: selectedOption && selectedOption.id,
    };
    if (guestUserId) {
      params["guest_user_id"] = guestUserId;
    }

    let geoId = localStorage.getItem("geolocation_val");
    if (geoId) {
      params["location_id"] = geoId;
    } else {
      params["location_id"] = null;
    }
    let lat = localStorage.getItem("latitude");
    let lng = localStorage.getItem("longitude");
    params["lat"] = lat;
    params["lng"] = lng;

    eventApi.callPickOption(
      params,
      (message: string, resp: any) => {
        console.log({ resp });
        if (resp) {
          closeOptionSelectionModal();
          userAction.guestUserId(resp);
          eventAction.updateEventDetailsUserAnswerData(resp, editAnswer);
          if (resp.guest_user_id) {
            localStorage.setItem("guestUserId", resp.guest_user_id);
          } else {
            localStorage.removeItem("guestUserId");
          }
          if (resp.tie_breaker_code) {
            setTieBreakerCode(resp.tie_breaker_code);
          }
          // getEventGameDetails(resp.guest_user_id)
          setTimeout(() => setOptionSelectionModalClosed(true), 500);
          toast.success(message);
          if (editAnswer) {
            showUserAnswersList();
            return;
          }
          setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
      },
      (message: string) => {
        closeOptionSelectionModal();
        toast.error(message);
      }
    );
  };

  const skipAnswer = () => {
    setOptionSelectionModal(false);
    if (editAnswer) {
      showUserAnswersList();
      return;
    }
    setCurrentQuestionIndex(currentQuestionIndex + 1);
  };

  const showUserAnswersList = () => {
    setAnyQuestionsAnswered(true);
    setEditAnswer(false);
  };

  const getYouPicks = () => {
    let params: any = {
      rodeo_event_id: e_id,
      performance_id: p_id,
    };
    if (guestUserId) {
      params["guest_user_id"] = guestUserId;
    }
    eventApi.callYourPicks(
      params,
      (message: string, resp: any) => {
        if (resp) {
          console.log({ resp });
          setPerformanceDetails(resp?.performance);
          setTeamDetails(resp?.team);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const onStatusModalClose = () => {
    setShowStatusModal(false);
  };

  const openOptionSelectionModal = (e: any, option: any) => {
    e && e.preventDefault();
    let found = eventGameDetailsSelector?.events?.user_answers?.find(
      (x: any) => x?.question_id == option?.question_id && x?.answer_id == option?.id
    );
    if (found) {
      if (editAnswer) {
        showUserAnswersList();
        return;
      }
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      return;
    }
    let winner = eventGameDetailsSelector?.events?.questions_dtls[currentQuestionIndex]?.winning_declare;
    console.log({ option });
    // if (winnerDeclared == "1") {
    if (winner == "1") {
      setShowStatusModal(true);
      setStatusModalMesssage("Winner has already been declared");
      return;
    } else if (pickStatus == "0") {
      setShowStatusModal(true);
      setStatusModalMesssage("Sorry, the picks are not open yet.");
      return;
    } else if ([2].includes(eventGameDetailsSelector?.events?.status)) {
      setShowStatusModal(true);
      setStatusModalMesssage("Event has ended. So you can no more pick an answer.");
      return;
    } else {
      if (!showOptionSelectionModal) {
        setOptionSelectionModal(true);
        setSelectedOption(option);
      }
    }
  };

  const closeOptionSelectionModal = () => {
    if (showOptionSelectionModal) setOptionSelectionModal(false);
    // continueNextEvent()
  };

  const onSuccessOptionSelectionVote = (status: boolean) => {
    if (status) {
      submitUserAnswer();
    }
  };

  const openPickedTeamModal = (type?: any) => {
    if (type == "myteam") {
      // setPerformanceDetails(eventGameDetailsSelector?.events?.performance_dtls)
      getYouPicks();
      // getMyTeam()
    }
    setShowPickedTeamModal(true);
  };

  const closePickedTeamModal = () => {
    setShowPickedTeamModal(false);
    setTeamDetails(null);
    setTieBreakerCode(null);
    // setPerformanceDetails(null)
  };

  const backToGameListingPage = (e: any) => {
    e.preventDefault();
    history.push(`/event/${eventId}/${performanceId}`);
  };

  const goToLeaderBoardPage = (e: any) => {
    e.preventDefault();
    history.push(`/result/${eventId}/${gameId}`);
  };

  const goToMostPopularPicksPage = () => {
    // history.push(`/result/${eventId}/${performanceId}`)
    history.push(`/most-popular-picks/${eventId}/${performanceId}`);
  };

  const getEventGameDetails = (guestId?: any) => {
    const params: any = {
      rodeo_event_event_id: g_id,
      rodeo_event_id: e_id,
      performance_id: p_id,
      game_id: eventListSelector?.game_details.id,
    };
    console.log({ params });
    if (!userDetails) {
      if (guestUserId) {
        params["guest_user_id"] = guestUserId;
      } else if (guestId) {
        params["guest_user_id"] = guestId;
      }
    }
    eventApi.callGetEventGameDetails(
      params,
      (message: string, resp: any) => {
        if (resp) {
          if (!resp?.events) {
            history.push(`/event/${eventId}/${performanceId}`);
            return;
          }
          let anyWinnerDeclared = resp?.events?.questions_dtls?.filter((x: any) => x?.winning_declare == 1);
          console.log({ anyWinnerDeclared });
          if (anyWinnerDeclared.length > 0) {
            showUserAnswersList();
          } else if (
            (resp?.events?.user_answers?.length > 0 &&
              resp?.events?.questions_dtls?.length > 0 &&
              resp?.events?.questions_dtls?.length >= resp?.events?.user_answers?.length) ||
            resp.events.status == 2
          ) {
            showUserAnswersList();
          } else if (resp?.events?.user_answers?.length == 0) {
            setAnyQuestionsAnswered(false);
          }
          setLoginReq(resp?.rodeo_event_dtls?.login_required);
          setPickStatus(resp?.events?.performance_dtls?.start_pick);
          console.log("api >>>>>>>>>");
          setWinnerDeclared(resp?.events?.winning_declare || 0);
          setIsLoading(false);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const openShareModal = (url: any) => {
    closePickedTeamModal();
    setPerformanceDetails(eventGameListSelector[0].performance_dtls);
    setUrl(url);
    setShowShareModal(true);
  };

  const closeShareModal = () => {
    setShowShareModal(false);
    setPerformanceDetails(null);
  };

  const editUserAnswer = (data: any, i: any) => {
    setAnyQuestionsAnswered(false);
    setCurrentQuestionIndex(i);
    setEditAnswer(true);
  };

  useEffect(() => {
    if (g_id) {
      console.log({ g_id });
      getEventGameDetails();
    }
  }, [g_id]);

  //Get localstorage game ids
  useEffect(() => {
    if (localStorage.getItem(RODEPICK_NEXT_GAME_IDS)) {
      let ids = localStorage.getItem(RODEPICK_NEXT_GAME_IDS)?.split(",");
      setNextGameIds(ids);
    }
  }, []);

  //Socket Implementation start here
  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket', 'polling'], // Prefer websocket, fallback to polling
    upgrade: true,
    rememberUpgrade: true,
  });

  useEffect(() => {
    if (userDetails) {
      socket.connect();

      socket.on(SOCKET_CHANNEL.VOTE_RIDER, (riders: any) => {
        eventAction.pushRiderWithVoteDetailsSocketDataIntoRiderList(riders);
      });

      socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
        eventAction.pushGameStatusChangeSocketDataIntoGameDetails(changeEventStatus, userDetails.id);
        if (changeEventStatus && changeEventStatus.status === 0 && changeEventStatus.id === g_id) {
          eventAction.emptyUserAnswers();
          history.push(`/event/${eventId}/${performanceId}`);
        }
        // if (changeEventStatus && changeEventStatus.status === 1 && changeEventStatus.id === g_id) {
        //   showUserAnswersList();
        // }
      });

      socket.on(SOCKET_CHANNEL.END_EVENT, (changeEventStatus: any) => {
        console.log("........", { changeEventStatus });
        if (changeEventStatus?.id === g_id) {
          eventAction.pushGameStatusChangeSocketDataIntoGameDetails(changeEventStatus, userDetails.id);
          showUserAnswersList();
        }
      });

      socket.on(SOCKET_CHANNEL.ANSWER_WINNER, (data: any) => {
        console.log(",,,,,,,,,", { data, g_id });
        if (data?.rodeo_event_event_id === g_id) {
          eventAction.updateEventDetailsUserAnswerWinnerData(data);
          showUserAnswersList();
        }
        if (data?.rodeo_event_event_id === g_id && data?.answer_contestant_details?.is_winner == 0) {
          getEventGameDetails();
        }
      });
    }

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.START_STOP_RP_EVENT, (data: any) => {
      // console.log({data})
      setPickStatus(data.rp_start_pick);
    });

    socket.on(SOCKET_CHANNEL.LOGIN_REQUIRED, (data: any) => {
      // console.log(data)
      if (
        e_id == data.rodeo_event_id &&
        gameDetails &&
        Object.keys(data.login_required).includes(String(gameDetails.id))
      ) {
        setLoginReq(data.login_required[gameDetails.id]);
      }
    });

    socket.on(SOCKET_CHANNEL.CONTESTANT_WINNER, (data: any) => {
      console.log(e_id, data.rodeo_event_id, data.performance_id, p_id, data.rodeo_event_event_id, g_id);
      // const p = useParams<any>();
      // console.log({ p, data });
      setContestWinData(data);
      // if (e_id == data.rodeo_event_id && data.performance_id == p_id && data.rodeo_event_event_id == g_id) {
      //   console.log("socket >>>>>>>>>");
      //   setWinnerDeclared(1);
      // }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    console.log({ contestWinData });

    if (
      e_id == contestWinData?.rodeo_event_id &&
      contestWinData?.performance_id == p_id &&
      contestWinData?.rodeo_event_event_id == g_id
    ) {
      console.log("socket >>>>>>>>>");
      setWinnerDeclared(1);
      setContestWinData(null);
    }
  }, [contestWinData, e_id, p_id, g_id]);

  useEffect(() => {
    let currentIndex: any = nextGameIds.findIndex((x: any) => x == g_id);
    let nextIndex: any = (currentIndex + 1) % nextGameIds.length;
    setNextGameArrayIndex(nextIndex);
  }, [eventGameDetailsSelector]);

  useEffect(() => {
    if (userDetails || loginReq == 0) {
      // history.push(`/event/${eventId}/${gameId}`)
    } else {
      localStorage.setItem("currentPage", `/event/${eventId}/${gameId}`);
      history.push(`${URLS.LOGIN}`);
    }
  }, [loginReq]);

  useEffect(() => {
    if (OptionSelectionModalClosed && eventGameListSelector?.length) {
      // let team: any = [];
      // // console.log({eventGameListSelector})
      // eventGameListSelector?.map((x: any) => {
      //   // console.log({x})
      //   if (x.ispicked) {
      //     let y = x.ispicked;
      //     y["event_name"] = x.event_name;
      //     y["rider"] = x?.riders?.find((r: any) => r.id == y.rider_id)?.name;
      //     // console.log({y})
      //     team.push(y);
      //   }
      // });
      // setTeamDetails(team);
      // setOptionSelectionModalClosed(false);
      // if (team?.length == eventGameListSelector?.length && !congratsShown) {
      //   // console.log("OpenTeamModal")
      //   setCongratsShown(true);
      //   openPickedTeamModal();
      //   getEventGameDetails();
      //   return;
      // }
      // // continueNextEvent();
      // // setOptionSelectionModalClosed(false)
    }
  }, [OptionSelectionModalClosed, eventGameListSelector]);

  useEffect(() => {
    if (eventGameDetailsSelector) {
      // if (eventGameDetailsSelector?.events?.user_answers?.length == 0) {
      //   setAnyQuestionsAnswered(false);
      // } else if (
      //   eventGameDetailsSelector?.events?.user_answers?.length > 0 &&
      //   eventGameDetailsSelector?.events?.questions_dtls?.length > 0 &&
      //   eventGameDetailsSelector?.events?.questions_dtls?.length >=
      //     eventGameDetailsSelector?.events?.user_answers?.length
      // ) {
      //   setAnyQuestionsAnswered(true);
      // }
    }
    console.log({ eventGameListSelector });
  }, [eventGameListSelector]);

  useEffect(() => {
    console.log({ anyQuestionsAnswered });
  }, [anyQuestionsAnswered]);

  useEffect(() => {
    return () => {
      eventAction.emptyGameDetails();
    };
  }, []);

  return (
    <React.Fragment>
      <GeoLocation />
      {isLoading ? null : (
        <>
          <div className="main-content-panel">
            <div className="team-list-panel pt-3">
              {/* {anyQuestionsAnswered && eventGameDetailsSelector?.events?.user_tiebreaker_details?.code ? ( */}
              {anyQuestionsAnswered ? (
                <UserAnswers editUserAnswer={editUserAnswer} />
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center team-list-title-panel gap-3">
                    <div className="team-list-title">
                      <h1>{eventGameDetailsSelector?.events?.performance_dtls?.title}</h1>
                    </div>
                    <div className="team-list-date">
                      <p>
                        {eventGameDetailsSelector?.events?.performance_dtls?.pdate
                          ? moment(eventGameDetailsSelector?.events?.performance_dtls?.pdate).format("MMM DD, YYYY")
                          : ""}
                      </p>
                    </div>
                  </div>
                  <div className="team-list-block team-list-completed">
                    <div className="d-flex gap-3 align-items-center">
                      <div className="team-list-icon">
                        <img
                          src={
                            eventGameDetailsSelector?.events?.event_dtls?.avatar?.id != 0
                              ? eventGameDetailsSelector?.events?.event_dtls?.avatar?.thumb
                              : "/images/no-image.png"
                          }
                          style={{ width: "100%" }}
                          alt={eventGameDetailsSelector?.events?.event_dtls?.title}
                        />
                      </div>
                      <div className="team-list-content flex-grow-1">
                        <h4>
                          {eventGameDetailsSelector?.events?.event_title ||
                            eventGameDetailsSelector?.events?.event_dtls?.title}
                        </h4>
                      </div>
                    </div>
                  </div>
                  {winnerDeclared && (
                    <div className="d-flex gap-3 align-items-center justify-content-center text-white">
                      <p>Winner Declared</p>
                    </div>
                  )}
                  {eventGameDetailsSelector?.events?.questions_dtls?.length > 0 ? (
                    <div className="team-list-steps-no mb-4">
                      {[...Array(eventGameDetailsSelector?.events?.questions_dtls?.length)].map((_, i) => (
                        <span
                          className={
                            "list-steps-no " +
                            (i < currentQuestionIndex ? "active" : i == currentQuestionIndex ? "current" : "")
                          }
                          key={i + 1}
                        >
                          {i + 1}
                        </span>
                      ))}
                    </div>
                  ) : null}

                  {currentQuestionIndex < eventGameDetailsSelector?.events?.questions_dtls?.length ? (
                    <QuestionWithOptions
                      currentQuestionIndex={currentQuestionIndex}
                      openOptionSelectionModal={openOptionSelectionModal}
                    />
                  ) : (
                    <>
                      <TieBreaker showUserAnswersList={showUserAnswersList} />
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          <Sponsor />
        </>
      )}

      {showOptionSelectionModal && (
        <OptionSelectionModal
          onClose={closeOptionSelectionModal}
          onSuccess={onSuccessOptionSelectionVote}
          shouldShow={showOptionSelectionModal}
          optionDetails={selectedOption}
          skipAnswer={skipAnswer}
        />
      )}

      {/* {
                showGuestSaveVoteModal &&
                <GuestSaveVoteModal
                    onClose={closeGuestSaveVoteModal}
                    onSuccess={onSuccessGuestSaveVoteModal}
                    shouldShow={showGuestSaveVoteModal}
                />
            } */}
      {showStatusModal && statusModalMesssage && (
        <StatusModal shouldShow={showStatusModal} onClose={onStatusModalClose} message={statusModalMesssage} type={1} />
      )}

      {showPickedTeamModal && teamDetails?.length && !performanceDetails && (
        // showPickedTeamModal && teamDetails?.length &&
        <PickedTeamModal
          shouldShow={showPickedTeamModal}
          onClose={closePickedTeamModal}
          teamDetails={teamDetails}
          openShareModal={openShareModal}
          tieBreakerCode={tieBreakerCode}
        />
      )}

      {showPickedTeamModal && teamDetails?.length && performanceDetails && (
        <PickedTeamModal
          shouldShow={showPickedTeamModal}
          onClose={closePickedTeamModal}
          teamDetails={teamDetails}
          performanceDetails={performanceDetails}
          openShareModal={openShareModal}
        />
      )}

      {showShareModal && performanceDetails && url && (
        <ShareModal
          shouldShow={showShareModal}
          onClose={closeShareModal}
          performanceDetails={performanceDetails}
          url={url}
        />
      )}
    </React.Fragment>
  );
}
